import {
  ContentType,
  HomepageBannerContent,
  HomePageItemMix,
  ManualContent,
} from '../../redux-toolkits/home-page/homePage.type'
import { SingleEssential } from '../../redux-toolkits/lists/list.types'
import { ListCategoryDoc } from '../../redux-toolkits/categories/categories.type'
import { Product } from '../../redux-toolkits/products/products.type'
import { StrippedVendor } from '../../redux-toolkits/vendors/vendors.types'
import { Article } from '../../redux-toolkits/lists/list.types'
import { HPGoodList } from './homePageArticleCard'
import { HPCreator } from './homePageCreatorCard'
import { HPEssential } from './homePageEssentialCard'
import { HPExploreCard } from './homePageExploreCard'
import { HomePageMarketingBanner } from './homePageMarketingBanner'
import { HPProduct } from './homePageProductCard'
import { MiniCategoryCard } from './miniCategoryCard'

export const HomeItemCard = ({
  type,
  item,
  id,
  sortable,
  className = '',
  onRemove,
}: {
  type: ContentType
  item?: HomePageItemMix | ManualContent | HomepageBannerContent
  id: string
  sortable?: boolean
  className?: string
  onRemove?: () => void
}) => {
  return (
    <>
      {type === 'CREATORS' && (
        <HPCreator
          creator={item as StrippedVendor}
          id={id}
          sortable={sortable}
          className={className}
          onRemove={onRemove}
        />
      )}

      {type === 'ESSENTIALS' && (
        <HPEssential
          essential={item as SingleEssential}
          id={id}
          sortable={sortable}
          className={className}
          onRemove={onRemove}
        />
      )}

      {type === 'GOOD_LISTS' && (
        <HPGoodList
          article={item as Article}
          id={id}
          sortable={sortable}
          className={className}
          onRemove={onRemove}
        />
      )}

      {type === 'PRODUCTS' && (
        <HPProduct
          product={item as Product}
          id={id}
          sortable={sortable}
          className={className}
          onRemove={onRemove}
        />
      )}

      {type === 'CATEGORIES' && (
        <MiniCategoryCard
          category={item as ListCategoryDoc}
          id={id}
          onRemove={onRemove}
        />
      )}

      {type === 'MANUAL_ITEM' && (
        <HPExploreCard
          item={item as ManualContent}
          id={id}
          sortable={sortable}
          className={className}
          onRemove={onRemove}
        />
      )}

      {type === 'HOMEPAGE_BANNER' && (
        <HomePageMarketingBanner
          item={item as HomepageBannerContent}
          id={id}
          sortable={sortable}
          className={className}
          onRemove={onRemove}
        />
      )}
    </>
  )
}
